export const COMMENT_FAILED = 'comment-failed'
export const COMMENT = 'comment'
export const CART = 'cart'
export const NOTIFICATION = 'notification'
